import { useEffect } from "react";

export function useReveal() {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.add("reveal-active");
    const els = Array.from(document.querySelectorAll(".reveal"));
    const revealAll = () =>
      document.querySelectorAll(".reveal:not(.in-view)").forEach((el) => el.classList.add("in-view"));
    if (!("IntersectionObserver" in window)) {
      revealAll();
      return;
    }
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -5% 0px" }
    );
    els.forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add("in-view");
      else obs.observe(el);
    });
    const fallback = setTimeout(revealAll, 1800);
    return () => {
      obs.disconnect();
      clearTimeout(fallback);
    };
  }, []);
}

export default useReveal;
